import React from "react";
import setDataId from "../../../testing";

export default function Grid(props) {
  const { className, fluid, noGutters, ...rest } = props;
  if (rest["data-id"]) {
    delete rest["data-id"];
  }
  return (
    <div
      data-id={setDataId(props["data-id"])}
      className={`container${fluid ? "-fluid" : ""}${
        noGutters ? " no-gutters" : ""
      } ${className ? className : ""}`}
      {...rest}
    >
      {props.children}
    </div>
  );
}

Grid.displayName = "Grid";
